import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getPrivacyPolicy, updatePrivacyPolicy } from "../../../redux/actions/contentAction";

export default function Index() {
    const dispatch = useDispatch();

    const [privacyPolicyData, setPrivacyPolicyData] = useState({
        heading: "",
        paragraphText: "",
    });

    useEffect(() => {
        dispatch(getPrivacyPolicy(setPrivacyPolicyData));
    }, [dispatch]);

    const updatePrivacyPolicyData = () => {
        dispatch(updatePrivacyPolicy(privacyPolicyData, setPrivacyPolicyData));
    };

    return {
        privacyPolicyData,
        setPrivacyPolicyData,
        dispatch,
        updatePrivacyPolicyData,
    };
}
